import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload } from "../../actions"
import Title from "../general/title"
import moment from "moment"
import numeral from "numeral"
import Modal from "react-responsive-modal"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import BuyerModal from "containers/entry/modals/buyer"
import { toast } from "react-toastify"
import { storePref, checkPref, removePref } from "helpers/pref"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import settings from "settings"
import classnames from "classnames"
import classNames from "classnames"
import CompleteModal from "../entry/modals/complete"
import StartModal from "../entry/modals/start"
import currentUser from "helpers/currentUser"
import BustoutModal from "../entry/modals/bustout"
import ContractModal from "../entry/modals/contract"
import TransferModal from "../entry/modals/transfer"
import EstimatedModal from "../entry/modals/estimated"
import ClosingModal from "../entry/modals/closing"
import MoveInDate from "../entry/modals/moveInDate"
import WebsiteInfoBuilders from "../entry/modals/websiteInfoBuilders"
import ArcViewApprovedLot from "../entry/modals/arcViewApprovedLot"
import EditHomeInfo from "../entry/modals/editHomeInfo"

class LotInventory extends Component {
	constructor(props) {
		super(props)
		let pref = checkPref("portal__lotInventory__filtered")
		this.user = currentUser()
		this.fullUser = _.find(this.props.payload.users, { id: this.user?.id })
		this.state = {
			loading: true,
			valid: false,
			id: 0,
			transferModal: false,
			startModal: false,
			completeModal: false,
			closingModal: false,
			buyerModal: false,
			contractModal: false,
			bustoutModal: false,
			data: {},
			filtered: pref ? pref : [],
		}
	}

	getColumnWidth = (data, accessor, headerText) => {
		if (typeof accessor === "string" || accessor instanceof String) {
			accessor = (d) => d[accessor]
		}
		const maxWidth = 600
		const magicSpacing = 10
		const cellLength = Math.max(...data.map((row) => (`${accessor(row)}` || "").length), headerText.length)
		return Math.min(maxWidth, cellLength * magicSpacing)
	}

	buildTable = () => {
		let ret = []
		let twoMonths = moment().subtract(1, "week").unix()
		_.forEach(this.props.payload.salesManagerPayload.lots, (r) => {
			if (!this.props.activeProperties.includes(r.property)) {
				return
			}
			let property = _.find(this.props.payload.public.properties, { id: r.property })
			let sec = _.find(this.props.payload.public.sections, { id: r.section_id })
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let section = sec ? sec.name : ""
			let community = _.find(this.props.payload.public.properties, { id: r.property })
			let salesperson = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
			let needPaperwork = false
			let requirePaperworkBeforeClosing = settings.requirePaperworkBeforeClosing
			let viewPlans
			let start,
				saleActions,
				contractActions,
				profile,
				complete,
				arc,
				estimatedClosing,
				openHouse,
				lotReservations,
				websiteInfo,
				move_in_date,
				final,
				editHomeInfo,
				construction_status

			if (r.model == 1) {
				r.sale_status = "Model"
			} else if (r.closing_date) {
				r.sale_status = "Closed"
			} else if (!r.closing_date && r.sale_id) {
				r.sale_status = "Contract"
			} else if (r.lot_status == "Bustout") {
				r.sale_status = "Bustout"
			} else {
				r.sale_status = ""
			}

			if (!r.takedown_date) {
				r.const_status = ""
			} else if (r.complete_date) {
				r.const_status = "Complete"
			} else if (r.start_date) {
				r.const_status = "Slab"
			} else {
				r.const_status = "Vacant"
			}

			//? Buyer Paperwork
			if (this.fullUser?.manager_paperwork) {
				if (r.sale_id && property.no_paperwork !== 1) {
					let awaitingOrRejected = false
					_.forEach(r.documents, (v) => {
						if (v.status !== "accepted") {
							needPaperwork = true
						}
						if (["awaiting", "rejected"].includes(v.status)) {
							awaitingOrRejected = true
						}
					})
					if (!r.documents) {
						needPaperwork = true
					}
					if (needPaperwork) {
						let att
						if (requirePaperworkBeforeClosing && awaitingOrRejected) att = "btn--attention"
						profile = (
							<button className={`btn ${att}`} onClick={() => this.buttonClick("buyerModal", r)}>
								Buyer Paperwork
							</button>
						)
					}
				}
			}
			//? End buyer paperwork
			//? Sale actions
			if (settings?.enabled?.salesManager?.addSaleStatus) {
				if (r.lot_status == "Contract") {
					let att
					if (r.estimated_closing < twoMonths) att = "btn--attention"
					estimatedClosing = (
						<button className={`btn ${att}`} onClick={() => this.buttonClick("estimatedModal", r)}>
							Edit Estimated Closing
						</button>
					)
				}
				if (!r.sale_date && !r.closing_date) {
					contractActions = (
						<span>
							<button className="btn" onClick={() => this.buttonClick("contractModal", r)}>
								Add Contract
							</button>
						</span>
					)
				}
				if (r.sale_date && !r.closing_date && !r.bustout_date) {
					let closing
					if (r.sale_date && !r.closing_date) {
						closing = (
							<button className="btn" onClick={() => this.buttonClick("closingModal", r)}>
								Add Closing
							</button>
						)
						if (requirePaperworkBeforeClosing && needPaperwork) closing = null
					}
					contractActions = (
						<span>
							<button className="btn" onClick={() => this.buttonClick("bustoutModal", r)}>
								Cancel Contract
							</button>
							<button className="btn" onClick={() => this.buttonClick("transferModal", r)}>
								Transfer Lot
							</button>
							{closing}
						</span>
					)
				}
			}
			//? End sale actions

			//? ARC Stuff
			if (r.arc_approved && _.has(r.arc_data, `approval_date`)) {
				// This is split out because thsi means pipsy was in control when this was approved.  If it's not, like during import of a new developer, then we probably won't have this info.
				viewPlans = (
					<button className="btn darkGreen" onClick={() => this.buttonClick("viewApproved", r)}>
						View Approved Plans
					</button>
				)
			}
			// Final review logic
			if (!settings?.disabled?.finalReview) {
				if (settings.arc && (r?.arc_data?.fr === null || r?.arc_data?.fr === false) && r.complete_date) {
					// rejected fr
					final = (
						<button
							className={classNames("btn", {
								"btn--attention": r?.arc_data?.fr === false,
							})}
							onClick={() => this.buttonClick("finalModal", r)}>
							Resubmit Final Review
						</button>
					)
				} else if (settings.arc && r?.arc_data?.fr === undefined && r.complete_date) {
					// no fr
					final = (
						<button className="btn" onClick={() => this.buttonClick("finalModal", r)}>
							Submit Final Review
						</button>
					)
				}
			}
			//? End ARC
			//? Construction buttons
			if (settings?.enabled?.salesManager?.addConstructionStatus) {
				if (!r.start_date && !settings?.disableBuilderConstructionStatus) {
					start = (
						<button
							className={classnames("btn", { "btn--attention": r.missing_start })}
							onClick={() => this.buttonClick("startModal", r)}>
							Add Start
						</button>
					)
				}
				if (r.start_date && !r.complete_date && !settings?.disableBuilderConstructionStatus) {
					complete = (
						<button
							className={classnames("btn", { "btn--attention": r.missing_complete })}
							onClick={() => this.buttonClick("completeModal", r)}>
							Add Complete
						</button>
					)
				}
			}
			//? end construction buttons

			//? Home and website info buttons
			if (_.get(settings, `enabled.builderWebsiteInfo`) && r.start_date && !r.closing_date) {
				// Check that this property is using the public app - what if they aren't using our app?
				websiteInfo = (
					<button className="btn" onClick={() => this.buttonClick("websiteInfoModal", r)}>
						Website Info
					</button>
				)
			}
			let homeInfo = _.get(settings, `enabled.builderEditHomeInfo`)
			if (homeInfo?.enabled) {
				if ((homeInfo.requireStartDate && r.start_date) || !homeInfo.requireStartDate) {
					editHomeInfo = (
						<button className="btn" onClick={() => this.buttonClick("editHomeInfoModal", r)}>
							Home Info
						</button>
					)
				}
			}
			if (r.start_date && !r.complete_date && !r.sale_id) {
				move_in_date = (
					<button className={classnames("btn", {})} onClick={() => this.buttonClick("moveInDateModal", r)}>
						Edit Move In Date
					</button>
				)
			}
			// If ARC Approved isn't set, do not allow start
			if (settings.arcRequireApprovalBeforeStart && !r.arc_approved) {
				start = null
			}
			//? end home and website info buttons
			let actions = (
				<div>
					{start}
					{complete}
					{saleActions}
					{contractActions}
					{profile}
					{estimatedClosing}
					{arc}
					{viewPlans}
					{openHouse}
					{lotReservations}
					{websiteInfo}
					{editHomeInfo}
					{move_in_date}
					{final}
				</div>
			)
			ret.push({
				section: section,
				block: r.block,
				lot: r.lot,
				builder: builder.name,
				address: r.address,
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				buyer_last: r.primary_last,
				//buyer_first: r.primary_first,
				sale_date: r.sale_date,
				start_date: r.start_date,
				complete_date: r.complete_date,
				price: r.price,
				closing_date: r.closing_date,
				community: community && community.name,
				documents: r.documents,
				buyer_status: r.sale_status,
				construction_status: r.const_status,
				actions,
				profile,
			})
		})
		return ret
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	buttonClick = (modal, data) => {
		this.setState({
			[modal]: true,
			data,
		})
	}

	renderInventory = () => {
		let rows = this.buildTable()
		const columns = [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => {
					if (r._original.builder && r._original.builder.toLowerCase().includes(f.value.toLowerCase())) {
						return true
					}
				},
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => {
					if (
						r._original.salesperson &&
						r._original.salesperson.toLowerCase().includes(f.value.toLowerCase())
					) {
						return true
					}
				},
			},
			{
				Header: "Section",
				accessor: "section",
				width: this.getColumnWidth(rows, "section", "Section"),
				filterMethod: (f, r) => helpers.tableText(f, r, "section"),
			},
			{
				Header: "Block",
				accessor: "block",
				width: this.getColumnWidth(rows, "block", "Block"),
			},
			{
				Header: "Lot",
				accessor: "lot",
				width: this.getColumnWidth(rows, "lot", "Lot"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Construction Status",
				show: true,
				accessor: "construction_status",
				filterMethod: (f, r) => helpers.tableText(f, r, "construction_status"),
			},
			{
				Header: "Buyer Status",
				accessor: "buyer_status",
				show: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_status"),
			},
			{
				Header: "Buyer Last",
				accessor: "buyer_last",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
			},
			{
				Header: "Contract Date",
				accessor: "sale_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Sale Price",
				accessor: "price",
				filterable: false,
				Cell: (props) => (props.value ? numeral(props.value).format("$0,00") : ""),
				maxWidth: 125,
			},
			{
				Header: "Start Date",
				accessor: "start_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Complete Date",
				accessor: "complete_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Closing Date",
				accessor: "closing_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
		]
		if (this.fullUser?.manager_paperwork) {
			columns.push({
				Header: "Paperwork",
				accessor: "profile",
				filterable: false,
			})
		}
		if (
			settings?.enabled?.salesManager?.addConstructionStatus ||
			settings?.enabled?.salesManager?.addSaleStatus ||
			settings?.enabled?.builderWebsiteInfo
		) {
			columns.unshift({
				Header: "Actions",
				accessor: "actions",
				filterable: false,
				minWidth: 250,
			})
		}
		return (
			<div>
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="salesManager__lotInventory"
					title="Lot Inventory"
					classNames={"small"}
				/>
				<Modal
					classNames={{ modal: "modalForm" }}
					open={this.state.buyerModal}
					onClose={() => this.setState({ buyerModal: false })}
					center>
					<BuyerModal data={this.state.data} notify={this.notify} name="buyerModal" />
				</Modal>
			</div>
		)
	}

	render() {
		return (
			<div className="lotInventory">
				<div className="imageGroup">
					<Title title="Lot Inventory" showDate={false} />
					<div className="content">{this.renderInventory()}</div>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.bustoutModal}
						onClose={() => this.setState({ bustoutModal: false })}
						center>
						<BustoutModal data={this.state.data} notify={this.notify} name="bustoutModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.transferModal}
						onClose={() => this.setState({ transferModal: false })}
						center>
						<TransferModal data={this.state.data} notify={this.notify} name="transferModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.closingModal}
						onClose={() => this.setState({ closingModal: false })}
						center>
						<ClosingModal data={this.state.data} notify={this.notify} name="closingModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.contractModal}
						onClose={() => this.setState({ contractModal: false })}
						center>
						<ContractModal data={this.state.data} notify={this.notify} name="contractModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.startModal}
						onClose={() => this.setState({ startModal: false })}
						center>
						<StartModal data={this.state.data} notify={this.notify} name="startModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.completeModal}
						onClose={() => this.setState({ completeModal: false })}
						center>
						<CompleteModal data={this.state.data} notify={this.notify} name="completeModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.estimatedModal}
						onClose={() => this.setState({ estimatedModal: false })}
						center>
						<EstimatedModal data={this.state.data} notify={this.notify} name="estimatedModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.moveInDateModal}
						onClose={() => this.setState({ moveInDateModal: false })}
						center>
						<MoveInDate data={this.state.data} notify={this.notify} name="moveInDateModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.buyerModal}
						onClose={() => this.setState({ buyerModal: false })}
						center>
						<BuyerModal data={this.state.data} notify={this.notify} name="buyerModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.viewApproved}
						onClose={() => this.setState({ viewApproved: false })}
						center>
						<ArcViewApprovedLot data={this.state.data} notify={this.notify} name="viewApproved" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.websiteInfoModal}
						onClose={() => this.setState({ websiteInfoModal: false })}
						center>
						<WebsiteInfoBuilders data={this.state.data} notify={this.notify} name="websiteInfoBuilders" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.editHomeInfoModal}
						onClose={() => this.setState({ editHomeInfoModal: false })}
						center>
						<EditHomeInfo data={this.state.data} notify={this.notify} name="editHomeInfoModal" />
					</Modal>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		trafficSources: state.trafficSources,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(LotInventory))
